/**
 * Targets for 15 Dec 2026 (monetization spec, section 3), each with today's baseline so a tile
 * can show how far along it is. `baseline: null` = no baseline measured yet.
 *
 * The same numbers are copied in the backend's `bigquery/reports/2026-10-20-monetization-weekly.sql`
 * (the `targets` CTE), so change both together.
 */
export interface Target {
  target: number;
  baseline: number | null;
  higherIsBetter: boolean;
}

export const TARGETS = {
  arpdauUsd: { target: 0.015, baseline: 0.005, higherIsBetter: true },
  payerRate: { target: 0.01, baseline: 0.0033, higherIsBetter: true },
  arppuInr: { target: 150, baseline: 107, higherIsBetter: true },
  cartToPurchase: { target: 0.15, baseline: 0.035, higherIsBetter: true },
  adImpressionsPerDau: { target: 1.2, baseline: 0.107, higherIsBetter: true },
  repeatPayers7d: { target: 0.3, baseline: 0.12, higherIsBetter: true },
  refundShare: { target: 0.02, baseline: null, higherIsBetter: false },
} as const satisfies Record<string, Target>;

export type TargetKey = keyof typeof TARGETS;
